/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type { IntlService } from 'ember-intl';
import type { TicketStatus } from 'walden-fast/types/ticket';
import { t } from 'walden-fast/utils/intl';

export interface TicketStateTagSignature {
  Args: {
    state: TicketStatus;
  };
}

const VARIANTS: Record<TicketStatus, string> = {
  closed: 'gray',
  open: 'green',
};

const translationKeyMap: Record<TicketStatus, string> = {
  closed: t('components.ticketStateTag.closed'),
  open: t('components.ticketStateTag.open'),
};

export default class TicketStateTagComponent extends Component<TicketStateTagSignature> {
  @service('intl') declare intl: IntlService;

  get variant() {
    return VARIANTS[this.args.state];
  }

  get stateTranslation() {
    return this.intl.t(translationKeyMap[this.args.state]);
  }
}
